import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { EventCategoryService } from '../proxy/controlling/controllers/event-category.service';

FieldBuilder.setNamespace('Controlling');

export const EVENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Event.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('eventCategoryId', 'Entity.EventCategory', EventCategoryService)
    .displayFromNested('eventCategory.name')
    .sortBy('eventCategory.name')
    .build(),
];

export const EVENT_CONFIG = {
  entityName: 'Event',
  localizationKey: 'Controlling::Entity.Event',
  fields: EVENT_FIELDS,
  permission: 'General.Events',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
